import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { MutationTypes } from './mutation-types'
import { apolloClient } from '@/plugins/vue-apollo'
import SearchQuery from '@/graphql/shippingAddress/SearchQuery.gql'
import CreateMutation from '@/graphql/shippingAddress/CreateMutation.gql'
import UpdateMutation from '@/graphql/shippingAddress/UpdateMutation.gql'
import DeleteMutation from '@/graphql/shippingAddress/DeleteMutation.gql'
import ChangeMainMutation from '@/graphql/shippingAddress/ChangeMainMutation.gql'
import {
  ShippingAddress,
  CreateShippingAddressInput,
  UpdateShippingAddressInput,
} from '@/types/generated/graphql'

export interface ShippingAddressState {
  shippingAddresses: ShippingAddress[]
}

export const shippingAddress: Module<ShippingAddressState, RootState> = {
  namespaced: true,
  state: () => ({
    shippingAddresses: [],
  }),
  getters: {
    ofId: (state) => (id: string) => {
      return state.shippingAddresses.find((sa) => sa.shippingAddressId === id)
    },
  },
  mutations: {
    [MutationTypes.CLEAR_SHIPPING_ADDRESS](state) {
      state.shippingAddresses = []
    },
    [MutationTypes.CREATE_SHIPPING_ADDRESS](state, payload: ShippingAddress) {
      state.shippingAddresses.push(payload)
    },
    [MutationTypes.UPDATE_SHIPPING_ADDRESS](state, payload: ShippingAddress) {
      state.shippingAddresses = state.shippingAddresses.map(
        (shippingAddress) => {
          if (shippingAddress.shippingAddressId === payload.shippingAddressId) {
            return Object.assign({}, shippingAddress, payload)
          }
          return shippingAddress
        }
      )
    },
    [MutationTypes.DELETE_SHIPPING_ADDRESS](state, payload: ShippingAddress) {
      state.shippingAddresses = state.shippingAddresses.filter(
        (shippingAddress) =>
          shippingAddress.shippingAddressId !== payload.shippingAddressId
      )
    },
    [MutationTypes.CHANGE_MAIN_SHIPPING_ADDRESS](
      state,
      payload: ShippingAddress
    ) {
      state.shippingAddresses.forEach((shippingAddress) => {
        shippingAddress.main =
          shippingAddress.shippingAddressId === payload.shippingAddressId
      })
    },
  },
  actions: {
    fetch: async ({ commit }) => {
      const { data } = await apolloClient.query({
        query: SearchQuery,
        fetchPolicy: 'network-only', // FIXME
      })
      commit(MutationTypes.CLEAR_SHIPPING_ADDRESS)
      data.shippingAddresses.forEach((shippingAddress: ShippingAddress) => {
        commit(MutationTypes.CREATE_SHIPPING_ADDRESS, shippingAddress)
      })
    },
    register: async (
      { commit },
      shippingAddressInput: CreateShippingAddressInput
    ) => {
      const { data } = await apolloClient.mutate({
        mutation: CreateMutation,
        variables: {
          input: shippingAddressInput,
        },
      })
      commit(MutationTypes.CREATE_SHIPPING_ADDRESS, data.createShippingAddress)
    },
    update: async (
      { commit },
      shippingAddressInput: UpdateShippingAddressInput
    ) => {
      const { data } = await apolloClient.mutate({
        mutation: UpdateMutation,
        variables: {
          input: shippingAddressInput,
        },
      })
      commit(MutationTypes.CREATE_SHIPPING_ADDRESS, data.updateShippingAddress)
    },

    deleteAddress: async ({ commit }, id: string) => {
      const { data } = await apolloClient.mutate({
        mutation: DeleteMutation,
        variables: {
          id: id,
        },
      })
      commit(MutationTypes.DELETE_SHIPPING_ADDRESS, data.deleteShippingAddress)
    },
    changeMain: async ({ commit }, id: string) => {
      const { data } = await apolloClient.mutate({
        mutation: ChangeMainMutation,
        variables: {
          id: id,
        },
      })
      commit(
        MutationTypes.CHANGE_MAIN_SHIPPING_ADDRESS,
        data.changeMainShippingAddress
      )
    },
  },
}
